import moment from 'moment'

// ─────────────────────────────────────────────────────────────────────────────
//  Chamadas do cadastro/onboarding. Nenhum segredo aqui: só o token da sessão
//  do próprio lead (o mesmo "nekb" do login). Asaas, YCloud e SES ficam na API.
// ─────────────────────────────────────────────────────────────────────────────

const BASE_URL = process.env.REACT_APP_BASE_URL

export class ErroApi extends Error {
    constructor(mensagem, status, corpo) {
        super(mensagem)
        this.status = status
        this.corpo = corpo || {}
    }
}

// A sessão do painel expira 60 min depois do login (App.checkIsAuth). No
// onboarding o lead pode levar mais que isso preenchendo — cada chamada que
// dá certo renova o relógio, então só cai quem ficou parado de verdade.
const renovarSessao = () => {
    if (localStorage.getItem('nekb')) localStorage.setItem('exp', moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'))
}

export async function chamar(metodo, caminho, corpo, { autenticado = true } = {}) {
    let res
    try {
        res = await fetch(BASE_URL + caminho, {
            method: metodo,
            headers: {
                'Content-Type': 'application/json',
                ...(autenticado ? { Authorization: 'Bearer ' + localStorage.getItem('nekb') } : {})
            },
            ...(corpo ? { body: JSON.stringify(corpo) } : {})
        })
    } catch (e) {
        throw new ErroApi('Sem conexão com a BIWAPP. Confira sua internet e tente de novo.', 0)
    }
    const json = await res.json().catch(() => ({}))
    if (!res.ok) {
        throw new ErroApi(json.erro || json.error || json.message || 'Algo deu errado. Tente de novo.', res.status, json)
    }
    if (autenticado) renovarSessao()
    return json
}

export const api = {
    planos: () => chamar('GET', '/signup/planos', null, { autenticado: false }),
    iniciar: (dados) => chamar('POST', '/signup/start', dados, { autenticado: false }),
    // chave: a do /signup/start — prova que é o dono do cadastro (o signupId sozinho é previsível)
    confirmar: (signupId, codigo, chave) => chamar('POST', '/signup/verify', { signupId, codigo, chave }, { autenticado: false }),
    reenviar: (signupId, chave) => chamar('POST', '/signup/resend', { signupId, chave }, { autenticado: false }),
    // ETAPA 2 (depois do e-mail confirmado): o código que chega no WhatsApp do responsável. Só existe quando o /signup/verify do e-mail devolveu 409 falta:'whatsapp'
    verificarWhatsapp: (signupId, chave, codigo) => chamar('POST', '/signup/whatsapp/verificar', { signupId, chave, codigo }, { autenticado: false }),
    reenviarWhatsapp: (signupId, chave) => chamar('POST', '/signup/whatsapp/reenviar', { signupId, chave }, { autenticado: false }),
    corrigirWhatsapp: (signupId, chave, celular) => chamar('POST', '/signup/whatsapp/numero', { signupId, chave, celular }, { autenticado: false }),
    situacao: (signupId, chave) => chamar('POST', '/signup/situacao', { signupId, chave }, { autenticado: false }),

    estado: () => chamar('GET', '/onboarding/estado'),
    cnpj: (doc) => chamar('GET', '/onboarding/cnpj/' + doc),
    cep: (cep) => chamar('GET', '/onboarding/cep/' + cep),
    salvarLoja: (loja) => chamar('POST', '/onboarding/loja', loja),
    // suportePremium: a ativação só é cobrada com ele (o preço sai da API)
    escolherPlano: (planoId, suportePremium = false) => chamar('POST', '/onboarding/plano', { plano_id: planoId, suporte_premium: !!suportePremium }),
    assinar: (metodo) => chamar('POST', '/onboarding/assinatura', { metodo }),
    pagamento: () => chamar('GET', '/onboarding/pagamento'),
    simularPagamento: () => chamar('POST', '/onboarding/pagamento/simular', {}),
    aplicarCupom: (codigo) => chamar('POST', '/onboarding/cupom', { codigo }),
    removerCupom: () => chamar('DELETE', '/onboarding/cupom'),
    conectarWhatsapp: (wabaId) => chamar('POST', '/onboarding/whatsapp', { waba_id: wabaId }),
    pularWhatsapp: () => chamar('POST', '/onboarding/whatsapp/pular', {}),
    sessao: () => chamar('GET', '/onboarding/sessao')
}

// WhatsApp da BIWAPP para clientes novos e leads (o mesmo do site) — a I.A.
// de atendimento da BIWAPP responde na hora e chama a equipe quando precisa
export const AJUDA_WHATSAPP = 'https://wa.me/5511939501767?text='
export const linkAjuda = (texto) => AJUDA_WHATSAPP + encodeURIComponent(texto)
